// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"visually-hidden_visuallyHidden__igWkL"};